import { lzSAtomWithLocalStorage } from '@lz-store/services';
import LzMUser from '@lz-models/commons/User';

const lzSAuthUserAtom = lzSAtomWithLocalStorage<LzMUser | null>('authUserState', null);

export default lzSAuthUserAtom;
